import { CONTENT_FITNESS_ASSESSMENT_MODE } from "../../../enums/content-fitness";
import { CONTENT_FITNESS_FRAMEWORK_VERSION } from "../version";
import { anchors, type ContentFitnessSubcriterion, deferred } from "./types";

export const BRAND_TRUST_CONSISTENCY_SUBCRITERIA = [
  deferred(
    "brand_trust_consistency.brand_foundation_identity",
    "Brand Foundation & Identity",
    "brand_trust_consistency",
    1,
    CONTENT_FITNESS_ASSESSMENT_MODE.RUBRIC,
    "Scores whether the page expresses brand purpose, positioning, promise and personality rather than generic copy.",
  ),
  deferred(
    "brand_trust_consistency.imagery_art_direction",
    "Imagery & Art Direction",
    "brand_trust_consistency",
    2,
    CONTENT_FITNESS_ASSESSMENT_MODE.HYBRID,
    "Scores whether the visual identity system is applied on-brand across imagery, type, colour, icons and layout.",
  ),
  {
    key: "brand_trust_consistency.tone_voice_messaging_audience",
    version: CONTENT_FITNESS_FRAMEWORK_VERSION,
    label: "Tone of voice, messaging & audience",
    parentMetricKey: "brand_trust_consistency",
    order: 3,
    assessmentMode: CONTENT_FITNESS_ASSESSMENT_MODE.RUBRIC,
    pilot: true,
    definition:
      "Scores whether voice traits, messaging, nomenclature and audience framing align with active brand guidance.",
    evidenceGuidance:
      "Use page copy, active TOV/Brand Guidelines, approved and avoided terms, messaging framework, claims, glossary and page type.",
    applicabilityNotes:
      "When no active TOV version exists, score visible consistency only and mark guideline-linked evidence unavailable. Do not present guideline claims without active guidance.",
    anchors: anchors(
      "Voice or messaging materially contradicts brand guidance or audience framing.",
      "Voice is mostly generic, off-message or inconsistent with important guideline rules.",
      "Some voice and messaging alignment exists, but material gaps in traits, value proposition, naming or audience framing remain.",
      "Voice and messaging are aligned overall, with minor local drift.",
      "Voice, messaging, naming and audience framing clearly express the brand and its current guidance.",
    ),
    objectiveChecks: [
      "avoided terms",
      "required terms",
      "active TOV version",
      "rule-linked matches/violations",
      "competitor-style language",
    ],
  },
  deferred(
    "brand_trust_consistency.editorial_style_language",
    "Editorial style & language",
    "brand_trust_consistency",
    4,
    CONTENT_FITNESS_ASSESSMENT_MODE.HYBRID,
    "Scores whether grammar, spelling, capitalisation, punctuation and approved terminology follow editorial style guidance.",
  ),
] as const satisfies readonly ContentFitnessSubcriterion[];
